import React, {useEffect, useMemo} from "react";
import {useSelector} from "react-redux";
import {log} from "../../logging/logEvent";
import {CentredLoader} from "../elements/Loader";
import styled from "styled-components";
import PageHeading from "../elements/PageHeading";
import NotFoundPage from "../app/NotFoundPage";
import {useParams} from "react-router";
import {CSS_GE_L, CSS_GE_M, CSS_GE_S, CSS_GE_XL, CSS_GE_XXL} from "./breakpoints";

const HelpVideoPlayer = ({videoHash}) => {
    const helpVideos = useSelector(state => state.helpVideos)
    useEffect(() => {
        log("PageComponentMounted", {page: "HelpVideosPlayer"})
    }, [])
    const {videoId} = useParams()

    const video = useMemo(() => {
        const videoUri = `/videos/${videoId}`
        return (helpVideos.videos || []).find(it => it.uri === videoUri)
    }, [videoId, helpVideos.videos])

    if (!helpVideos.videos) {
        return <div style={{padding: 20}}><CentredLoader/></div>;
    }

    if (!video) {
        return <NotFoundPage/>
    }

    const videoUrlQuery = videoHash ? `h=${videoHash}` : ''
    const playerUrl = `https://player.vimeo.com/video/${videoId}${videoUrlQuery}`
    return (
        <VideoPageContainer>
            <VideoContainer>
                <VideoIFrame src={playerUrl} allow="fullscreen" allowFullscreen/>
            </VideoContainer>
            {video.name && <VideoName>{video.name}</VideoName>}
            {video.description && <VideoDescription>{video.description}</VideoDescription>}
        </VideoPageContainer>
    )
}

const VideoPageContainer = styled.div`
  width: auto;
  margin: 60px auto 0 auto;

  // XS by default
  max-width: 296px;

  @media (${CSS_GE_S}) {
    max-width: 616px;
  }

  @media (${CSS_GE_M}) {
    max-width: 782px;
  }

  @media (${CSS_GE_L}) {
    max-width: 684px;
  }

  @media (${CSS_GE_XL}) {
    max-width: 1008px;
  }

  @media (${CSS_GE_XXL}) {
    max-width: 1158px;
  }
`;

const VideoName = styled(PageHeading)`
  padding-left: 18px;
  padding-top: 30px;
  padding-bottom: 30px;
`;

const VideoDescription = styled.p`
`;

const VideoContainer = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;
  padding-bottom: 56.2%;
`

const VideoIFrame = styled.iframe`
  width: 100%;
  height: 100%;
  border: 0;
  top: 0;
  left: 0;
  position: absolute;
`

export default HelpVideoPlayer;
